import {FormGroup, ValidationErrors, Validator} from '@angular/forms';

/**
 * at least one checkbox must be checked
 */
export class CheckboxesGroupRequiredValidator implements Validator {

    public static validator() {
        const validator = new CheckboxesGroupRequiredValidator();
        return (group: FormGroup): ValidationErrors | null => validator.validate(group);
    }

    validate(group: FormGroup): ValidationErrors | null {

        const values = group.value;
        const atLeastOneValueFound = Object.keys(values).find(key => values[key]);
        return atLeastOneValueFound ? null : {'required': true};
    }
}
